module.exports = "/images/ANGER.png?20434aff43e17389bd239bc322f5ed95";